import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import styled from '@emotion/styled';
import RCInputNumber from 'rc-input-number';

const StyledInput = styled.input `
  font-family: Roboto, sans-serif;
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  color: rgba(0, 0, 0, 0.85);
  height: 32px;
  padding: 0 0.5rem;
  font-size: 12px;
  line-height: 1.25rem;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  &:focus,
  &-focused {
    outline: 0;
  }
  &::-moz-placeholder {
    opacity: 1;
  }

  &::placeholder {
    color: #bfbfbf;
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }
  &.small {
    padding: 0 0.25rem;
    height: 24px;
  }
  &.large {
    font-size: 13px;
    height: 40px;
    padding: 0.5rem;
  }
  &.borderless {
    &,
    &:hover,
    &:focus,
    &-focused,
    &-disabled,
    &[disabled] {
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }
  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
const Input = (props) => {
    const { size = 'default', className, bordered = true, value } = props, rest = __rest(props, ["size", "className", "bordered", "value"]);
    const getClassName = () => {
        let cls = size;
        if (className) {
            cls += ` ${className}`;
        }
        if (!bordered) {
            cls += ' borderless';
        }
        return cls;
    };
    return (jsx(StyledInput, Object.assign({ value: value || '', className: getClassName() }, rest)));
};

const StyledTextarea = styled.textarea `
  font-family: Roboto, sans-serif;
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  height: auto;
  min-height: 2rem;
  font-size: 13px;
  line-height: 1.25rem;
  background-color: #ffffff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all 0.3s;
  padding: 0.5rem;
  color: rgba(0, 0, 0, 0.85);
  &:focus,
  &-focused {
    outline: 0;
  }
  &::-moz-placeholder {
    opacity: 1;
  }

  &::placeholder {
    color: #bfbfbf;
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  &.small {
    padding: 0 0.25rem;
  }
  &.large {
    font-size: 13px;
    padding: 0.5rem;
  }
  &.borderless {
    &,
    &:hover,
    &:focus,
    &-focused,
    &-disabled,
    &[disabled] {
      background-color: transparent;
      border: none;
      box-shadow: none;
    }
  }
`;
const Textarea = (props) => {
    const { rows = 4, className, bordered = true, size = 'default' } = props, rest = __rest(props, ["rows", "className", "bordered", "size"]);
    const getClassName = () => {
        let cls = size;
        if (className) {
            cls += ` ${className}`;
        }
        if (!bordered) {
            cls += ' borderless';
        }
        return cls;
    };
    return jsx(StyledTextarea, Object.assign({ rows: rows, className: getClassName() }, rest));
};

const StyledInputNumber = styled(RCInputNumber) `
  &.rc-input-number {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    border-radius: 4px;
    background-color: #ffffff;

    &.small input {
      height: 22px;
      padding: 0;
    }
    &.large input {
      height: 38px;
      padding: 0 0.5rem;
    }
    &.borderless input {
      &,
      &:hover,
      &:focus,
      &-focused,
      &-disabled,
      &[disabled] {
        background-color: transparent;
        border: none;
        box-shadow: none;
      }
    }

    input {
      border-radius: 4px;
      padding: 0 0.5rem;
      color: inherit;
      height: 32px;
      width: 100%;
      text-align: inherit;
      background-color: inherit;
      border: 1px solid #d9d9d9;
      outline: 0;
      transition: all 0.3s linear;
      -moz-appearance: textfield !important;

      &::-moz-placeholder {
        opacity: 1;
      }

      &::placeholder {
        color: #bfbfbf;
      }
    }
  }
`;
const InputNumber = (props) => {
    const { onChange, size = 'default', className, bordered = true, value } = props, rest = __rest(props, ["onChange", "size", "className", "bordered", "value"]);
    const getClassName = () => {
        let cls = size;
        if (className) {
            cls += ` ${className}`;
        }
        if (!bordered) {
            cls += ' borderless';
        }
        return cls;
    };
    return (jsx(StyledInputNumber, Object.assign({ value: value, onChange: (val) => {
            if (val === null) {
                onChange(undefined);
            }
            else
                onChange(val);
        }, className: getClassName() }, rest)));
};

export { Input as I, StyledInput as S, Textarea as T, InputNumber as a };
